import { emptyCalendar, emptyDay } from "../common/types";
import { writable, derived } from "svelte/store";
import 'robot3/debug';
const internalCalendar = writable(emptyCalendar);
const internalSelectedDay = writable(emptyDay);
export const calendar = derived(internalCalendar, $c => $c);
export const selectedDay = derived(internalSelectedDay, $d => $d);
const reduceWeek = (week, day) => (Object.assign(Object.assign({}, week), { days: week.days.map(d => d.day == day.day ? day : d) }));
const reduceCalendar = (calendar, day) => (Object.assign(Object.assign({}, calendar), { weeks: calendar.weeks.map(w => reduceWeek(w, day)) }));
export const setSelectedDay = (day) => {
    internalSelectedDay.set(day);
    internalCalendar.update(c => reduceCalendar(c, day));
};
const findDayInCalendar = (day, calendar) => calendar.
    weeks.
    map(w => w.days).reduce((a, b) => [...a, ...b]).
    find(d => d.day == day.day);
export const setCalendar = (calendar) => {
    internalCalendar.set(calendar);
    internalSelectedDay.update(d => {
        const foundDay = findDayInCalendar(d, calendar);
        return foundDay == undefined ? d : foundDay;
    });
};
export const initialize = (calendar, selectedDay) => {
    setSelectedDay(selectedDay);
    setCalendar(calendar);
};
